/* eslint-disable no-shadow, no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

import {
  ANIMALS,
  PAGE_CONGRATULATIONS,
  PAGE_GAME,
  PAGE_UNSUPPORTED,
  PAGE_WELCOME,
  PAGES,
  STORAGE_KEY,
} from 'constants';

import audioFormat from 'lib/audioFormat';
import getGlobalPoints from 'lib/getGlobalPoints';
import reloadAd from 'lib/reloadAd';
import track from 'lib/track';

Vue.use(Vuex);

const animalKeys = ANIMALS.map(a => a.key);

const defaultState = {
  animal: animalKeys[0],
  expertMode: false,
  globalPoints: null,
  page: audioFormat ? PAGE_WELCOME : PAGE_UNSUPPORTED,
  points: 0,
  audioFormat,
};

const state = (() => {
  try {
    return {
      ...defaultState,
      ...JSON.parse(localStorage[STORAGE_KEY]),
    };
  } catch (e) {
    return { ...defaultState };
  }
})();

const mutations = {
  incrementPoints(state) {
    state.points += 1;
  },
  setAnimal(state, animal) {
    if (animalKeys.indexOf(animal) !== -1) {
      state.animal = animal;
    }
  },
  setExpertMode(state, enabled) {
    state.expertMode = !!enabled;
  },
  setGlobalPoints(state, value) {
    state.globalPoints = parseInt(value, 10);
  },
  setPage(state, page) {
    if (PAGES.indexOf(page) !== -1) {
      state.page = page;
    }

    if (page === PAGE_GAME) {
      track('Cow', 'gameStart', state.animal);
    } else if (page === PAGE_CONGRATULATIONS) {
      track('Cow', 'gameStop', state.animal);
      Vue.nextTick(reloadAd);
    }
  },
};

const actions = {
  incrementPoints: ({ commit }) => commit('incrementPoints'),
  setAnimal: ({ commit }, animal) => commit('setAnimal', animal),
  setExpertMode: ({ commit }, enabled) => commit('setExpertMode', enabled),
  setGlobalPoints: ({ commit }, value) => commit('setGlobalPoints', value),
  setPage: ({ commit }, page) => commit('setPage', page),
  find: ({ commit }) => {
    commit('incrementPoints');
    commit('setPage', PAGE_CONGRATULATIONS);
    getGlobalPoints(true).then(p => commit('setGlobalPoints', p));
  },
  getGlobalPoints: ({ commit }) => {
    getGlobalPoints().then(p => commit('setGlobalPoints', p));
  },
};

const getters = {};

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});

store.subscribe((mutation, state) => {
  if (typeof localStorage === 'object') {
    const stateToSave = {
      animal: state.animal,
      points: state.points,
    };
    localStorage[STORAGE_KEY] = JSON.stringify(stateToSave);
  }
});

store.dispatch('getGlobalPoints');

export default store;



// WEBPACK FOOTER //
// ./src/store.js